// Button styling changes
document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.btn--add-to-cart');
  addToCartButtons.forEach(button => {
    button.classList.remove('btn--outline');
    button.classList.add('btn');
  });
});

// Cart drawer functionality - show drawer when product added (for regular pages)
document.addEventListener('theme:cart:popdown', (e) => {
  const listener = (e) => {
    document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        bubbles: false,
      })
    );
    document.removeEventListener('theme:cart:change', listener);
  };
  document.addEventListener('theme:cart:change', listener);
});

// PageFly cart helper for Pipeline theme - efficient initialization
function initPageFly() {
  try {
    if (window.__pagefly_helper_store__) {
      // PageFly is ready, set up subscription
      console.log('PageFly initialized, setting up cart subscription');
      
      window.__pagefly_helper_store__.subscribe(function (res) {
        $.getJSON('/cart.json').then(cart => {
          console.log('PageFly cart update:', cart);
          
          // Trigger Pipeline's cart change event
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true
          }));
          
          // Also open the cart drawer directly for PageFly pages
          const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
          if (cartDrawer) {
            cartDrawer.dispatchEvent(
              new CustomEvent('theme:drawer:open', {
                bubbles: false,
              })
            );
          }
        });
      });
    } else {
      // Not ready yet, check again in 100ms
      setTimeout(initPageFly, 100);
    }
  } catch (e) {
    console.warn('PageFly initialization error:', e);
    // Try again in case it was a temporary issue
    setTimeout(initPageFly, 200);
  }
}

// Close cart drawer when continue shopping is clicked
document.addEventListener('click', function(e) {
  if (e.target.matches('[data-close-cart-drawer]')) {
    e.preventDefault(); // Prevent the # link from doing anything
    
    // Close the cart drawer using Pipeline's drawer system
    const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (cartDrawer) {
      cartDrawer.dispatchEvent(
        new CustomEvent('theme:drawer:close', {
          bubbles: false,
        })
      );
    }
  }
});

// Start checking for PageFly immediately
initPageFly();